import { format, isBefore, isSameYear, startOfWeek } from "date-fns/esm"
import { hu } from "date-fns/esm/locale"
import type { WP_REST_API_Attachment, WP_REST_API_Post } from "wp-types"

export const upperFirst = (str: string) => str.charAt(0).toUpperCase() + str.slice(1)

export const formatDate = (d: Date | string) => {
    d = new Date(d)
    let date = format(d, 'EEEE', { locale: hu })
    const now = new Date()
    if (isBefore(d, startOfWeek(now))) {
        date =
            format(
                d,
                `${isSameYear(now, d) ? '' : 'y. '}MMMM. dd., `, { locale: hu }
            ) + date
    }

    return upperFirst(date)
}

export const hashCode = (str: string) => {
    let hash = 0;
    if (str.length === 0) return hash;
    for (let i = 0; i < str.length; i++) {
        const chr = str.charCodeAt(i);
        hash = ((hash << 5) - hash) + chr;
        hash |= 0; // Convert to 32bit integer
    }
    return Math.abs(hash);
};

export function parseHtmlEntities(str: string) {
    return str.replace(/&#([0-9]{1,4});/gi, function (_, numStr) {
        const num = parseInt(numStr, 10); // read num as normal number
        return String.fromCharCode(num);
    });
}

export interface MediaMeta {
    src: string
    srcset: string
    alt: string
    width: number
    height: number
}

export function mapMedia(media: WP_REST_API_Attachment): MediaMeta {
    const sizes = Object.values(media.media_details.sizes).filter(s => s.width !== s.height).map((size) => `${size.source_url}.webp ${size.width}w`)
    return {
        src: media.source_url,
        alt: media.alt_text || media.caption.rendered || media.title.rendered,
        srcset: sizes.join(', '),
        width: +media.media_details.width,
        height: +media.media_details.height
    }
}

export type MappedPost = WP_REST_API_Post & {
    featuredMedia: MediaMeta;
};


export function withFeaturedMedia(post: WP_REST_API_Post): MappedPost {
    const featuredMedia = post._embedded?.['wp:featuredmedia']?.[0] as any;
    return {
        ...post,
        featuredMedia: featuredMedia ? mapMedia(featuredMedia) : {} as any
    };

}

export function debounce(fn: Function, delay: number) {
    let timer: number;
    return (...args: any[]) => {
        clearTimeout(timer);
        timer = window.setTimeout(() => fn(...args), delay);
    }
}